(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-custom')) {
    class ProductCardCustom extends HTMLElement {
      connectedCallback() {
        const wishlistButton = this.querySelector('[data-wishlist-toggle]');
        if (wishlistButton) {
          this.syncWishlistButton(wishlistButton);
          wishlistButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.toggleWishlist(wishlistButton);
          });
        }
      }

      getWishlist() {
        try {
          return JSON.parse(localStorage.getItem('pc-wishlist') || '[]');
        } catch (e) {
          return [];
        }
      }

      saveWishlist(list) {
        try {
          localStorage.setItem('pc-wishlist', JSON.stringify(list));
        } catch (e) {
          /* localStorage no disponible (modo privado, etc.) */
        }
      }

      syncWishlistButton(button) {
        const id = button.getAttribute('data-product-id');
        const active = this.getWishlist().indexOf(id) !== -1;
        button.setAttribute('data-active', active ? 'true' : 'false');
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      toggleWishlist(button) {
        // Favoritos compartidos con el resto del sitio (misma clave que
        // los carruseles de la home), guardados en el navegador del cliente.
        const id = button.getAttribute('data-product-id');
        const list = this.getWishlist();
        const idx = list.indexOf(id);
        let nowActive;

        if (idx === -1) {
          list.push(id);
          nowActive = true;
        } else {
          list.splice(idx, 1);
          nowActive = false;
        }

        this.saveWishlist(list);
        button.setAttribute('data-active', nowActive ? 'true' : 'false');
        button.setAttribute('aria-pressed', nowActive ? 'true' : 'false');

        window.dispatchEvent(new CustomEvent('pc:wishlist-change', {
          detail: { productId: id, active: nowActive, wishlist: list },
        }));
      }
    }

    customElements.define('product-card-custom', ProductCardCustom);
  }
  } catch(e) { console.error(e); }
})();

})();
